export default (theme) => ({
  container: {
    padding: 5,
  },
  select: { color: theme.palette.primary.color[600] },
});
